<template>
    <component :is="sectionComponent" v-bind="props" />
</template>

<script>
// import sectionRegistry from "../sectionRegistry.js";
import sectionRegistry from '@/sectionRegistry.js';

export default {
    name: "DynamicSection",
    props: {
        section: String,
        props: Object,
    },
    computed: {
        sectionComponent() {
            return sectionRegistry[this.section] || null;
        },
    },
};
</script>

<style>

</style>